import createCrudVuexModule from "@/store/crud";
import axios from "axios";
export const fileManager = createCrudVuexModule({
  moduleName: "fileManager",
  path: "/file-manager",
  namespaced: true,
  persistent: ["selectedEntity"],

  state: {
    uploadedFiles: [],
    downloadedFiles: [],
    pagination: undefined,
    pendingApprovalPagination: undefined,
    isLoading: false,
    storageInfo: undefined,
    selectedTab: 0,
  },

  getters: {
    uploadedFiles: (state) => state.uploadedFiles,
    downloadedFiles: (state) => state.downloadedFiles,
    pagination: (state) => state.pagination,
    pendingApprovalPagination: (state) => state.pendingApprovalPagination,
    storageInfo: (state) => state.storageInfo,
    isLoading: (state) => state.isLoading,
    isUploading: (state) => state.uploadedFiles.some((f) => f.status === "started"),
    isDownloading: (state) => state.downloadedFiles.some((f) => f.status === "started"),
    selectedTab: (state) => state.selectedTab,
  },
  mutations: {
    selectedTab: (state, value) => (state.selectedTab = value),
    addUploadedFile: (state, file) => {
      state.uploadedFiles.unshift(file);
    },

    fileUploadProgress: (state, { id, progress, status }) => {
      const index = state.uploadedFiles.findIndex((item) => item.id === id);
      state.uploadedFiles[index].progress = progress;
      state.uploadedFiles[index].status = status;
    },

    addDownloadedFile: (state, { file, isHistory = false, isApproval = false }) => {
      const check = state.downloadedFiles.find((f) => f.id == file._id);

      if (check) {
        return;
      }
      const downloadItem = {
        id: file._id,
        name: file.name,
        size: file.size,
        extension: file.approval?.path && isApproval ? file.approval.path.split(".").pop() : file.extension,
        status: "pending",
        progress: 0,
        isHistory,
        isApproval,
      };

      state.downloadedFiles.push(downloadItem);
    },
    removeDownloadingItem: (state, id) => {
      const index = state.downloadedFiles.indexOf(id);
      state.downloadedFiles.splice(index, 1);
    },

    removeUploadedItem: (state, id) => {
      const index = state.uploadedFiles.indexOf(id);
      state.uploadedFiles.splice(index, 1);
    },

    fileDownloadProgress: (state, { id, progress, status }) => {
      const index = state.downloadedFiles.findIndex((item) => item.id === id);
      state.downloadedFiles[index].progress = progress;
      state.downloadedFiles[index].status = status;
    },

    pagination: (state, value) => (state.pagination = value),
    pendingApprovalPagination: (state, value) => (state.pendingApprovalPagination = value),
    storageInfo: (state, value) => (state.storageInfo = value),
    isLoading: (state, value) => (state.isLoading = value),
    storageInfo: (state, value) => (state.storageInfo = value),
    isDownloLoading: (state, value) => (state.isDownloLoading = value),
  },
  actions: {
    async uploadFile({ commit, dispatch, getters }, { targetUrl, payload, file }) {
      const formData = new FormData();
      if (payload) {
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        formData.append("payload", JSON.stringify(payload));
      }

      formData.append("file", file);
      const id = (Math.random() + 1).toString(36).substring(7);
      const uploadItem = {
        id: id,
        name: file.name,
        size: file.size,
        status: "started",
        progress: 0,
      };
      commit("addUploadedFile", uploadItem);
      let response;
      try {
        response = await axios.post(targetUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            commit("fileUploadProgress", { id: uploadItem.id, progress: percentCompleted, status: "started" });
          },
        });

        if (response.status === 200) {
          commit("fileUploadProgress", { id: uploadItem.id, progress: 100, status: "success" });
        } else {
          commit("fileUploadProgress", { id: uploadItem.id, status: "error" });
        }
      } catch (error) {
        response = {
          error,
          status: 500,
        };
        commit("fileUploadProgress", { id: uploadItem.id, progress: 100, status: "error" });
      } finally {
        commit("removeUploadedItem", id);
        return response;
      }
    },

    async paginate({ commit }, pagination, clearStateBeforeRest = false) {
      commit("isLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("pagination", undefined);
        }
        const response = await axios.post(`file-manager/paginate`, { pagination });
        commit("pagination", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },
    async paginateSimple({ commit }, pagination, clearStateBeforeRest = false) {
      commit("isLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("pagination", undefined);
        }
        const response = await axios.post(`file-manager/simple-paginate`, { pagination });
        commit("pagination", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },
    async pendingApprovalPaginate({ commit }, pagination, clearStateBeforeRest = false) {
      commit("isLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("pendingApprovalPagination", undefined);
        }
        const response = await axios.post(`file-manager/paginate`, { pagination });
        commit("pendingApprovalPagination", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },

    async paginateFileForNos({ commit }, pagination, clearStateBeforeRest = false) {
      try {
        const response = await axios.post(`file-manager/no/paginate`, { pagination });

        return response;
      } finally {
      }
    },

    async fetchDetail({ commit }, id) {
      try {
        const response = await axios.get(`file-manager/` + id);

        return response.data;
      } finally {
      }
    },
    async startApprovalProcess({ commit }, id) {
      try {
        const response = await axios.get(`file-manager/${id}/start-approval-process`);

        return response.data;
      } finally {
      }
    },
    async storage({ commit }, clearStateBeforeRest = false) {
      commit("isLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("storageInfo", undefined);
        }
        const response = await axios.get(`file-manager/storage`);
        commit("storageInfo", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },

    async delete({ commit }, id) {
      return axios.delete(`file-manager/${id}`);
    },
    async download({ commit }, file) {
      commit("fileDownloadProgress", { id: file.id, progress: 0, status: "started" });

      try {
        const lang = this.getters["user/account"].language || "en";
        axios
          .get(`file-manager/download/${file.id}?isHistory=${file.isHistory}&isApproval=${file.isApproval}`, {
            responseType: "blob",
            onDownloadProgress: (progressEvent) => {
              let percentCompleted = Math.floor((progressEvent.loaded / progressEvent.total) * 100);
              commit("fileDownloadProgress", { id: file.id, progress: percentCompleted, status: "started" });
            },
          })
          .then((response) => {
            if (response.status === 200) {
              commit("fileDownloadProgress", { id: file.id, progress: 100, status: "success" });
              var fileURL = window.URL.createObjectURL(new Blob([response.data]));
              var fileLink = document.createElement("a");
              fileLink.href = fileURL;

              const hasExtInName = file.name[lang].split(".").pop() === file.extension;
              const fileName = hasExtInName ? file.name[lang] : file.name[lang] + "." + file.extension;

              fileLink.setAttribute("download", fileName);
              document.body.appendChild(fileLink);

              fileLink.click();
              commit("removeDownloadingItem", file.id);
            } else {
              commit("fileDownloadProgress", { id: file.id, status: "error" });
              commit("removeDownloadingItem", file.id);
            }
          });
      } catch (error) {
        commit("fileDownloadProgress", { id: file.id, status: "error" });
        commit("removeDownloadingItem", file.id);
      }
    },
  },
});

export const organizationFileCategory = createCrudVuexModule({
  namespaced: true,
  path: "/file-category",
  // persistent: ["selectedParentCategory", "selectedSubCategory"],
  state: { parentCategoryPagination: [], subCategoryPagination: [], selectedParentCategory: undefined, selectedSubCategory: undefined },
  getters: {
    parentCategoryPagination: (state) => state.parentCategoryPagination,
    subCategoryPagination: (state) => state.subCategoryPagination,
    selectedParentCategory: (state) => state.selectedParentCategory,
    selectedSubCategory: (state) => state.selectedSubCategory,
  },
  mutations: {
    parentCategoryPagination: (state, value) => (state.parentCategoryPagination = value),
    subCategoryPagination: (state, value) => (state.subCategoryPagination = value),
    selectedParentCategory: (state, value) => (state.selectedParentCategory = value),
    selectedSubCategory: (state, value) => (state.selectedSubCategory = value),
  },
  actions: {
    async paginateParentCategories({ commit }, pagination, clearStateBeforeRest = false) {
      commit("isLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("parentCategoryPagination", undefined);
        }
        const response = await axios.post(`file-category/paginate`, { pagination });
        commit("parentCategoryPagination", response.data);
        return response;
      } catch (error) {
      } finally {
        commit("isLoading", false);
      }
    },
    async paginateSubCategories({ commit }, { id, pagination }, clearStateBeforeRest = false) {
      commit("isLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("subCategoryPagination", undefined);
        }
        const response = await axios.post(`file-category/paginate/${id}`, { pagination });
        commit("subCategoryPagination", response.data);
        return response;
      } catch (error) {
      } finally {
        commit("isLoading", false);
      }
    },
  },
});

const preSave = (payload) => {
  if (payload.account) {
    payload.account = { _id: payload?.account?._id } || payload?.account?.accountId;
  }
  return payload;
};
export const organizationFileAccessibleAccounts = createCrudVuexModule({
  namespaced: true,
  path: "/file-accessible",

  state: {},
  getters: {},
  mutations: {},

  actions: {
    async deleteByAccountId({ commit }, { fileId, accountId }) {
      return axios.delete(`file-manager/${fileId}/accessible-account/${accountId}`);
    },

    async accessibleAccountsByFileId({ commit }, { fileId, pagination }, clearStateBeforeRest = false) {
      commit("isLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("parentCategoryPagination", undefined);
        }

        const response = await axios.post(`file-manager/${fileId}/accessible-accounts/paginate`, { pagination });
        commit("pagination", response.data);
        return response;
      } catch (error) {
      } finally {
        commit("isLoading", false);
      }
    },
    async create({ getters, commit, dispatch }, { fileId, payload }) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        payload = preSave(payload);
        const response = await axios.post(`file-manager/${fileId}/accessible-account`, { item: payload });
        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async update({ getters, commit, dispatch }, { fileId, payload }) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });
        payload = preSave(payload);
        const response = await axios.put(`file-manager/${fileId}/accessible-account`, { item: payload });
        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});
